import ReactDOM from "react-dom/client";
import GlobalContextProvider from "./Context/GlobalContext";
import { BrowserRouter } from "react-router-dom";
import { WishlistProvider } from "./Context/WishlistContext";
import { OrderClarificationProvider } from "./Context/OrderClarificationPopUpContext";
import { AuthProvider } from "./Context/AuthContext";
import { FlashLoaderProvider } from "./Context/FlashScreenContext";
import { GlobalFunctionProvider } from "./Context/GlobalFunctionContext";
import { LoginModalProvider } from "./Context/LoginModalContext";
import { FeedbackProvider } from "./Context/FeedbackContext";
import "./custom.css";
import "../src/assets/css/correction.css";
//Icons are not show when declare using cdn link
// import "../src/assets/css/header.css";
// import "../src/assets/css/footer.css";
// import "../src/assets/css/cartList.css";
// import "../src/assets/css/products.css";
// import "../src/assets/css/myaccount.css";
// import "../src/assets/css/login.css";
// import "../src/assets/plugins/datatable/css/jquery.dataTables.min.css";
// import "../src/assets/plugins/datatable/css/responsive.dataTables.min.css";
// import "../src/assets/plugins/fontawesome/css/fontawesome.min.css";
// import "../src/assets/plugins/fontawesome/css/all.min.css";
// import "../src/assets/plugins/wesicons/wes-icon.css";
import "@tabler/icons-webfont/dist/tabler-icons.min.css";

import { ModelAlertProvider } from "./Context/pleaseNote";
import { FlashScreenProvider } from "./Context/flashScreen";
import { CartProvider } from "./Context/CreateContext";
import { DeviceProvider } from "./Context/hook/useDeviceType";
import { ModalPopupManagerProvider } from "./Context/modelPopupContext";
import { InternetProtected } from "./InternetProtected";
import "react-toastify/dist/ReactToastify.css";
import { SnackbarProvider } from "notistack";
import ErrorBoundary from "./errorReporting/ErrorBoundary";
import { routesWithoutMasterConfig } from "./routeConfig";
import { TillPaymentProcessing } from "./View/CheckOutNew/Payment/tillPaymentProcessing";

// import './assets/js/jquery-3.7.0.min.js'
//import './assets/js/script.js'

const root = ReactDOM.createRoot(document.getElementById("root"));

const currentPath = window.location.pathname.toLowerCase();
const isGatewayReturnPage = routesWithoutMasterConfig.some((route) =>
  currentPath.startsWith(`/${route.toLowerCase()}`),
);

if (isGatewayReturnPage) {
  root.render(<TillPaymentProcessing />);
} else {
  root.render(
    <ErrorBoundary>
      <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
        <SnackbarProvider
          container={() => document.body}
          maxSnack={3}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <FlashLoaderProvider>
            <ModalPopupManagerProvider>
              <AuthProvider>
                <DeviceProvider>
                  <WishlistProvider>
                    <OrderClarificationProvider>
                      <FlashScreenProvider>
                        <ModelAlertProvider>
                          <GlobalContextProvider>
                            <CartProvider>
                              <GlobalFunctionProvider>
                                <LoginModalProvider>
                                  <FeedbackProvider>
                                    <InternetProtected />
                                  </FeedbackProvider>
                                </LoginModalProvider>
                              </GlobalFunctionProvider>
                            </CartProvider>
                          </GlobalContextProvider>
                        </ModelAlertProvider>
                      </FlashScreenProvider>
                    </OrderClarificationProvider>
                  </WishlistProvider>
                </DeviceProvider>
              </AuthProvider>
            </ModalPopupManagerProvider>
          </FlashLoaderProvider>
        </SnackbarProvider>
      </BrowserRouter>
    </ErrorBoundary>,
  );
}
